import { fetchButton } from "../index";
import { hackerNewsSourceUrl } from "../index";
import { blocker } from "../index";


export async function getHackerNews() {
    blocker.classList.add('show')

    const sourceUrl = hackerNewsSourceUrl;
    const hackerNewsResponse = await fetch(sourceUrl);
    let data = await hackerNewsResponse.json();
    try {
        data = data.response;
        fetchButton.disabled = false;
        for (let i in data) {
            let title = data[i].title;
            let url = data[i].url;
            let author = "Author: " + data[i].by;
            let comments = "Comments: " + data[i].descendants;
            let time = new Date(data[i].time * 1000);
            let score = "Score: " + data[i].score;
            let source = "Source: Hacker News";
            let commentsUrl = "https://news.ycombinator.com/item?id=" + data[i].id;

            let storyDiv = document.createElement("li");
            let anchor = document.createElement("a");
            let authorDiv = document.createElement("div");
            let timeDiv = document.createElement("div");
            let commentsDiv = document.createElement("div");
            let commentsLink = document.createElement("a");
            let sourceDiv = document.createElement("div");
            let scoreDiv = document.createElement("div");

            storyDiv.classList.add('story');
            anchor.classList.add('storyTitle')
            authorDiv.classList.add('author');
            sourceDiv.classList.add('source');
            timeDiv.classList.add('time');
            commentsDiv.classList.add('comments');
            scoreDiv.classList.add('time');

            authorDiv.append(author);
            sourceDiv.append(source);
            timeDiv.append(time);
            scoreDiv.append(score);
            commentsLink.append(comments);
            commentsDiv.append(commentsLink);
            commentsLink.setAttribute('href', commentsUrl);
            commentsLink.setAttribute('target', "_blank");

            anchor.setAttribute('href', url);
            anchor.setAttribute('target', "_blank");
            anchor.append(title);
            storyDiv.appendChild(anchor);
            storyDiv.append(authorDiv)
            storyDiv.append(sourceDiv);
            storyDiv.append(timeDiv);
            storyDiv.append(scoreDiv);
            storyDiv.append(commentsDiv);

            let hackerNewsBias = localStorage.getItem('hackerNewsBias')
            switch (hackerNewsBias) {
                case 'left':
                    leftColumn.insertAdjacentElement("afterBegin", storyDiv);
                    break;

                case 'center':
                    centerColumn.insertAdjacentElement("afterBegin", storyDiv);
                    break;

                case 'right':
                    rightColumn.insertAdjacentElement("afterBegin", storyDiv);
                    break;
                default:
                    leftColumn.insertAdjacentElement("afterBegin", storyDiv);
                    break;
            }
        }
    } catch (error) {
        console.log(error)
    }
}